import {forwardRef, InputHTMLAttributes, memo} from 'react';

const TextInput = forwardRef((props: InputHTMLAttributes<HTMLInputElement>, ref: React.ForwardedRef<HTMLInputElement>): JSX.Element => {
    return (
        <input ref={ref} {...props} />
    );
});

export default memo(TextInput);